<div class="block pos-relative">
    <button (click)="submit()"
            class="apple-pay-button"></button>
    @if(getRequestDataStatus.busy || !available){
    <div class="fill z-1 bg-col-w flex flex-middle flex-justify-center">
        <i class="icon-loading"></i>
    </div>
    }
</div>
@if(inProgressStatus.busy){
<span class="c1">{{'Payment in progress...' | translate}}
    <i class="icon-loading"></i>
</span>
}
<result [status]="availableStatus"
        [duration]="'permanent'"></result>
<result [status]="getRequestDataStatus"
        [duration]="'permanent'"></result>
<result [status]="validateMerchantStatus"
        [duration]="'permanent'"></result>
